export default __webpack_public_path__ + "static/media/emptyHand.c7534985.png";